import React from 'react';
import {
  Routes,
  Route
} from 'react-router-dom';

import IndexPage from './pages/Index.js';
import BlogPage from './pages/Blog.js';

function App() {
  return (
    <Routes>
      <Route path="/" element={<IndexPage />} />
         
      <Route path="/blog" element={<BlogPage />} />
    </Routes>
  );
}

export default App;
